import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, map } from 'rxjs';
import { AlertActions, HideAlert } from '../actions/alert.actions';

@Injectable()
export class AlertEffects {
    constructor(private actions$: Actions) {}

    showAlertHideEffect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AlertActions.ShowAlert),
            delay(5000),
            map(() => new HideAlert())
        )
    );
}
